import React from 'react';
import { useAppSelector } from '../../../../store';

export default function useGameProviderUtils() {
  const curLang = useAppSelector((state) => state.site.lang);
  const sourceNameById = useAppSelector((state) => state.gameProviders.sourceNameById);

  const getSourceName = (sourceId) => {
    return sourceNameById[sourceId] || sourceId;
  };

  const getCategoryName = (category) => {
    if (!category) return '';

    const namesLang = category[2];
    const name = namesLang[curLang];

    if (name) return name;

    for (let lang in namesLang) {
      const name = namesLang[lang];
      if (name) return name;
    }

    return '';
  };

  return { getCategoryName, getSourceName };
}
